import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export default function SubscriptionExpired({ details, onLogout }) {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-100">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <AlertTriangle className="mx-auto text-amber-500 mb-4" size={48} />
        <h1 className="text-xl font-semibold text-slate-900 mb-2">
          {t('subscription.expiredTitle') || 'Subscription inactive'}
        </h1>
        <p className="text-slate-600 mb-6">
          {details?.error || t('subscription.expiredMessage') || 'Your store subscription is not active. Please contact Numuw support.'}
        </p>
        <button
          type="button"
          onClick={onLogout}
          className="px-4 py-2 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700"
        >
          {t('auth.logout') || 'Log out'}
        </button>
      </div>
    </div>
  );
}
